import immer from 'immer';
import { StoreReducer } from 'types';

export * from './actions';
export * from './factories';
export * from './selectors';

export const paginationReducer: StoreReducer = immer(() => {}, {});
